import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import WeightInput from '../../common/WeightInput'; // Assuming the file location

const WeightInputComponent = () => {
    return (
        <div className="page-content components">
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Weight Input Showcase</h2>

                        {/* First Row - Required Weight Input */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <WeightInput
                                    label="Weight (required)"
                                    required={true}
                                    minValue={1}
                                    maxValue={150}
                                    helpText="Enter a weight between 1 and 150 units."
                                    showHelp={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<WeightInput
    label="Weight (required)"
    required={true}
    minValue={1}
    maxValue={150}
    helpText="Enter a weight between 1 and 150 units."
    showHelp={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row - Optional Weight Input */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <WeightInput
                                    label="Optional Weight"
                                    required={false}
                                    placeholder="Enter optional weight"
                                    showHelp={true}
                                    helpText="This field is optional."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<WeightInput
    label="Optional Weight"
    required={false}
    placeholder="Enter optional weight"
    showHelp={true}
    helpText="This field is optional."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row - Weight with Custom Unit */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <WeightInput
                                    label="Weight with Custom Unit"
                                    required={true}
                                    minValue={50}
                                    maxValue={200}
                                    defaultUnit="lb"
                                    unitOptions={["lb", "kg"]}
                                    helpText="Enter a weight in pounds (50 to 200 lb)."
                                    showHelp={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<WeightInput
    label="Weight with Custom Unit"
    required={true}
    minValue={50}
    maxValue={200}
    defaultUnit="lb"
    unitOptions={["lb", "kg"]}
    helpText="Enter a weight in pounds (50 to 200 lb)."
    showHelp={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row - Weight with Range Validation */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <WeightInput
                                    label="Weight with Range Validation"
                                    required={true}
                                    minValue={20}
                                    maxValue={80}
                                    helpText="Enter a weight between 20 and 80 units."
                                    showHelp={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<WeightInput
    label="Weight with Range Validation"
    required={true}
    minValue={20}
    maxValue={80}
    helpText="Enter a weight between 20 and 80 units."
    showHelp={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default WeightInputComponent;
